var e = {
	today: {
		title: "Today",
		subtitle: "Arrivals, departures and rooms for one property, one day at a time.",
		boardError: "We couldn't load the rooms for this property.",
		retry: "Try again",
		noProperties: {
			title: "No properties yet",
			body: "Add a property and its arrivals, departures and rooms appear here."
		},
		needsHousekeeping: {
			title: "Room access needed",
			body: "Today matches each stay to its room, which needs permission to view housekeeping. Ask a workspace owner to add it to your role."
		}
	},
	toolbar: {
		property: "Property",
		propertyPlaceholder: "Choose a property",
		untitledProperty: "Untitled property",
		previousDay: "Previous day",
		nextDay: "Next day",
		today: "Today"
	},
	tabs: {
		label: "Front desk lists",
		arrivals: "Arrivals ({{count}})",
		departures: "Departures ({{count}})",
		inHouse: "In-house ({{count}})",
		stayOver: "Stay-overs ({{count}})",
		rooms: "Rooms ({{count}})"
	},
	row: {
		unknownGuest: "Guest",
		noRoom: "No room",
		unnamedRoom: "Unnamed room",
		untitledRoomType: "Room type",
		ready: "Ready",
		outOfOrder: "Out of order",
		overdue: "Overdue",
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		guests_one: "{{count}} guest",
		guests_other: "{{count}} guests"
	},
	actions: {
		checkIn: "Check in",
		checkOut: "Check out",
		noShow: "Mark as no-show",
		reassign: "Reassign room",
		openBooking: "Open booking"
	},
	toast: {
		checkedIn: "Checked in",
		checkedOut: "Checked out",
		noShowMarked: "Marked as a no-show",
		failedTitle: "That didn't go through",
		failedBody: "We couldn't update this booking. Try again."
	},
	noShow: {
		title: "Mark this stay as a no-show?",
		body: "The guest never arrived. The room is released for the remaining nights, and the stay can't be checked in after this.",
		reasonLabel: "Reason (optional)",
		reasonPlaceholder: "For example: the guest didn't arrive and couldn't be reached",
		reasonMax: "Keep the reason under 300 characters",
		confirm: "Mark as no-show"
	},
	empty: {
		arrivals: {
			title: "No arrivals",
			body: "No guests are due to arrive on this day."
		},
		departures: {
			title: "No departures",
			body: "No guests are due to leave on this day."
		},
		inHouse: {
			title: "Nobody in-house",
			body: "No stays cover the night of this day."
		},
		stayOver: {
			title: "No stay-overs",
			body: "No guest arrived before this day and leaves after it."
		}
	},
	rooms: {
		freeTonight: "Free tonight",
		occupied: "Occupied",
		blocked: "Blocked",
		outOfOrder: "Out of order",
		overbookedTitle: "Overbooked nights ahead",
		overbooked_one: "{{date}} · {{count}} room short",
		overbooked_other: "{{date}} · {{count}} rooms short",
		noOverbooking: "No overbooking in the next 7 nights",
		empty: {
			title: "No rooms on this property",
			body: "Rooms appear here once the property has room types with rooms."
		},
		attention: {
			title: "Needs attention",
			outOfOrder_one: "{{room}} is out of order with {{count}} stay booked",
			outOfOrder_other: "{{room}} is out of order with {{count}} stays booked",
			arrivalNotReady: "{{room}} isn't ready for today's arrival",
			arrivalNotReadyStatus: "{{room}} is {{status}} and a guest arrives today",
			emptyTitle: "Nothing needs attention",
			emptyBody: "Every arrival has a ready room, and no out-of-order room holds a stay."
		},
		board: {
			title: "Housekeeping",
			filters: {
				status: "Status",
				occupancy: "Occupancy",
				myRooms: "My rooms",
				all: "All",
				search: "Search rooms",
				select: "Select",
				done: "Done",
				any: "Any",
				statusLabel: "Filter by housekeeping status"
			},
			occupancy: {
				arriving: "Arriving",
				departing: "Departing",
				stayOver: "Stay-over",
				vacant: "Vacant",
				outOfOrder: "Out of order",
				turnover: "Turnover"
			},
			actions: {
				markDirty: "Mark dirty",
				markClean: "Mark clean",
				markInspected: "Mark inspected",
				assign: "Assign",
				unassign: "Unassign",
				addNote: "Add note",
				editNote: "Edit note"
			},
			assign: {
				title: "Assign rooms",
				search: "Search team members",
				unassigned: "Not assigned",
				apply: "Assign",
				noMembers: "No team members match your search."
			},
			note: {
				title: "Room note",
				placeholder: "For example: the bathroom lamp needs replacing",
				save: "Save note",
				max: "Keep the note under {{count}} characters."
			},
			toast: {
				statusSaved: "Room status updated",
				assigned: "Rooms assigned",
				unassigned: "Rooms unassigned",
				noteSaved: "Note saved"
			},
			refusal: {
				ROOM_NOT_FOUND: "This room is no longer part of this property.",
				HOUSEKEEPING_INVALID_TRANSITION: "Only a clean room can be inspected. Mark it clean first.",
				ASSIGNEE_NOT_A_MEMBER: "That person is no longer on your team."
			},
			empty: {
				noRooms: "This property has no rooms to clean yet.",
				noMatch: "No rooms match these filters.",
				clearFilters: "Clear filters"
			},
			section: {
				dirty_one: "{{count}} dirty",
				dirty_other: "{{count}} dirty",
				clean_one: "{{count}} clean",
				clean_other: "{{count}} clean",
				inspected_one: "{{count}} inspected",
				inspected_other: "{{count}} inspected"
			},
			row: {
				open: "Housekeeping for {{room}}",
				select: "Select {{room}}",
				changed: "{{source}} · {{when}}",
				you: "You",
				someone: "A team member"
			},
			sheet: {
				assignedTo: "Assigned to",
				openRoom: "Open room"
			},
			bulk: {
				selected_one: "{{count}} room selected",
				selected_other: "{{count}} rooms selected",
				assign_one: "Assign {{count}}",
				assign_other: "Assign {{count}}"
			}
		}
	},
	widget: {
		title: "Today",
		titleProperty: "Today at {{property}}",
		arrivals: "Arrivals",
		departures: "Departures",
		inHouse: "In-house",
		freeTonight: "Rooms free tonight",
		open: "Open Today"
	},
	operations: {
		title: "Operations",
		description: "How rooms are turned over across every property in this workspace.",
		cardTitle: "Housekeeping",
		inspectionLabel: "Require an inspection before a room is ready",
		inspectionDescription: "A cleaned room counts as ready for an arrival only once someone has inspected it.",
		vacantLabel: "Mark a vacant room dirty after (days)",
		vacantHint: "A room left empty this many days needs cleaning again. 0 turns this off.",
		vacantRange: "Enter a whole number of days from 0 to 60",
		saved: "Operations settings saved",
		saveFailed: "We couldn't save the settings. Try again."
	}
};
//#endregion
export { e as default };
